module.exports = __webpack_public_path__ + "public/images/learn-to-draw-animals.1b1cc7a50ef7b4e974a07292c6baa77e.jpg";